import { c as _c } from "react/compiler-runtime";
import { FormattedMessage } from 'react-intl';
import Logo from 'shared/images/logo-black.svg';
// import settings from 'shared/settings';
import { Grid, Box, BoxProps } from './grid';
interface Props {
  medium?: string;
  source?: string;
}
const PoweredBy = t0 => {
  const $ = _c(11);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      medium: t1,
      source: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const medium = t1 === undefined ? "public-booking-page" : t1;
  const source = t2 === undefined ? "public-booking-page" : t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FormattedMessage id="Powered by" defaultMessage="Powered by" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `https://bookem.com?utm_source=${source}&utm_medium=${medium}&utm_campaign=powered-by-link`;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Logo alt="Bookem" width={91} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <Box lineHeight={1} display="block" color="gray.8" as="a" href={t4} target="blank">{t5}</Box>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== props || $[9] !== t6) {
    t7 = <Grid gridGap={2} flex="0 1 auto" textAlign="center" fontSize={1} mb={2} {...props}>{t3}{t6}</Grid>;
    $[8] = props;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export default PoweredBy;